import Navbar from '@/components/smartpos/Navbar';
import PricingSection from '@/components/smartpos/PricingSection';
import PlanManifesto from '@/components/smartpos/PlanManifesto';
import Footer from '@/components/smartpos/Footer';
import FloatingCTA from '@/components/smartpos/FloatingCTA';
import useDocumentMeta from '@/hooks/useDocumentMeta';
import { useLanguage } from '@/lib/LanguageContext';

const meta = {
  ES: { title: 'Precios y Planes — SmartPOS', desc: 'Descubre los planes y precios de SmartPOS: START, PRO y ELITE. Software TPV en la nube, hardware, CashDro, quioscos y más.' },
  EN: { title: 'Pricing and Plans — SmartPOS', desc: 'Discover SmartPOS plans and pricing: START, PRO and ELITE. Cloud POS software, hardware, CashDro, kiosks and more.' },
  CA: { title: 'Preus i Plans — SmartPOS', desc: 'Descobreix els plans i preus de SmartPOS: START, PRO i ELITE. Software TPV al núvol, hardware, CashDro, quioscos i més.' },
  FR: { title: 'Tarifs et Plans — SmartPOS', desc: 'Découvrez les plans et tarifs de SmartPOS : START, PRO et ELITE. Logiciel TPV cloud, hardware, CashDro, kiosques et plus.' },
};

export default function Precios() {
  const { lang } = useLanguage();
  const m = meta[lang] || meta.ES;
  useDocumentMeta({ title: m.title, description: m.desc, canonicalPath: '/precios' });

  return (
    <div className="min-h-screen font-body">
      <Navbar />
      <main id="contenido-principal">
        <PricingSection />
        <PlanManifesto />
      </main>
      <Footer />
      <FloatingCTA />
    </div>
  );
}